import { unifiedClient } from '@/lib/unified-fetch';

export interface Category {
  id: number;
  name: string;
  parentCategoryId?: number | null;
}

export const fetchAllCategories = async (): Promise<Category[]> => {
  try {
    const response = await unifiedClient.admin.GET('/event_Category/', {
      params: {
        query: {
          limit: 1000, // Get all categories
          offset: 0,
        },
      },
    });

    if (response.error) {
      throw new Error('Failed to fetch categories');
    }

    return response.data || [];
  } catch (error) {
    console.error('Error fetching categories:', error);
    return [];
  }
};
